import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

let authToken = null;

export const setAuthToken = (token) => {
  authToken = token;
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("cxoora_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("cxoora_token");
  }
};

export const getStoredToken = () => {
  const t = localStorage.getItem("cxoora_token");
  if (t) {
    api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
    authToken = t;
  }
  return t;
};

export default api;
